import { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import Cookies from "js-cookie"
import "react-datepicker/dist/react-datepicker.css"
import { useRouter } from "next/router"

function toDay() {
  return new Date()
}

function formatDate(time) {
  let date = new Date(time)
  let day = date.getDate().toString()
  let month = (date.getMonth() + 1).toString()
  return `${day} thg ${month}`
}

export default function BoxTimeLiveScore({ fetch, activeCategory }) {
  const dateInit = Cookies.get("date")
  const __date = dateInit ? new Date(dateInit) : toDay()
  const [isRender, setIsRender] = useState(false)
  const [selected, setSelected] = useState(__date)
  const router = useRouter()
  const [isMobile, setIsMobile] = useState(false)
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) {
        setIsMobile(true)
      } else {
        setIsMobile(false)
      }
    }

    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  function onClick() {
    const el = document.getElementsByClassName("react-datepicker__input-container")[0]
    el.childNodes[0].click()
  }

  function onChangeDate(value) {
    setSelected(value)
    fetch(value, activeCategory)
  }

  function goToPreviousDay() {
    const newDate = new Date(selected)
    newDate.setDate(newDate.getDate() - 1)
    setSelected(newDate)
    fetch(newDate, activeCategory)
  }

  function goToNextDay() {
    const newDate = new Date(selected)
    newDate.setDate(newDate.getDate() + 1)
    setSelected(newDate)
    fetch(newDate, activeCategory)
  }

  const goToToday = () => {
    const newDate = new Date()
    if (newDate.getDay() === selected.getDay()) return
    setSelected(newDate)
    fetch(newDate, activeCategory)
  }

  useEffect(() => {
    goToToday()
  }, [router])

  useEffect(() => {
    if (window) {
      const el = document.getElementsByClassName("react-datepicker__input-container")[0]
      el.childNodes[0].style.display = "none"
      setIsRender(true)
    }

    window.addEventListener("beforeunload", () => {
      Cookies.remove("date")
    })
    return () => window.removeEventListener("beforeunload", null)
  }, [])

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center">
        <div className="flex flex-col gap-3 w-full">
          <div className="text-[32px] leading-10 font-semibold text-[#afafaf] max-sm:hidden max-lg:text-[26px]">
            Lịch thi đấu
          </div>
          <div className="flex w-full justify-between">
            <div className="flex flex-col" onClick={isMobile ? onClick : undefined}>
              <div className="max-sm:text-[11px] max-sm:leading-4 text-base leading-5 font-normal text-[#afafaf]">
                {convertDay(selected.getDay())}
              </div>
              <div className="text-[32px] max-sm:text-[24px] leading-10 font-semibold text-[#fafaf9]">
                {formatDate(selected)}
              </div>
            </div>
            <div className="flex gap-3 items-center">
              <div id="id" style={{ display: isRender ? "block" : "none" }}>
                <DatePicker
                  dateFormat="dd/MM/yyy"
                  selected={selected}
                  onChange={onChangeDate}
                  popperPlacement="bottom-end"
                />
              </div>
              <button className="max-sm:hidden" onClick={onClick}>
                <img src="/icons/iconCalendarSchedule.svg" />
              </button>
              <div className="flex gap-2 bg-[#232323] items-center p-1 rounded-lg">
                <button onClick={goToPreviousDay}>
                  <img src="/icons/iconArrowLeftSchedule.svg" />
                </button>
                <div
                  className={
                    ("px-1 font-medium", isSameDay(new Date(), selected) ? "text-[#5F5F5F]" : "cursor-pointer")
                  }
                  onClick={goToToday}
                >
                  Hôm nay
                </div>
                <button onClick={goToNextDay}>
                  <img src="/icons/iconArrowRightSchedule.svg" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function convertDay(day) {
  if (day === 0) return "Chủ nhật"
  const _day = day + 1
  return "Thứ " + _day
}

function isSameDay(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  )
}
